"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockContractWithNoDefaultPayable__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "customPayable",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode = "0x6080604052348015600f57600080fd5b50605980601d6000396000f3fe608060405260043610601c5760003560e01c80634148cf15146021575b600080fd5b00fea2646970667358221220c15b58c2e5eac49488607f8edcccff82ebe8b5043f9ba1f14be614d3da00858b64736f6c63430008110033";
const isSuperArgs = (xs) => xs.length > 1;
class MockContractWithNoDefaultPayable__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.MockContractWithNoDefaultPayable__factory = MockContractWithNoDefaultPayable__factory;
//# sourceMappingURL=MockContractWithNoDefaultPayable__factory.js.map